<template>
  <div class="login" v-if="this.$store.state.isLogin">
    <div class="login-container" >
      <div class="login-wrapper">
        <div class="close" @click="closeClick"></div>
        <div class="login-type-list">
          <div :class="['login-type-item',index === loginTypeId ? 'active' : '']" v-for="(item,index) in loginTypeList" :key="index" @click="loginTypeClick(index)">{{item.text}}</div>
        </div>
        <div :class="{phone:true,isFocus:isFocusPhone}">
          <img src="../assets/images/index/phone.png" alt="">
          <input @input="phoneInput" @blur="handleBlurPhone" @focus="hanldeFocusPhone" v-model="getPhoneNumber" type="text" placeholder="请输入手机号码">
          <div class="close" v-if="phoneData" @click="phoneDataClick"></div>
        </div>
        <div class="identifyType" v-if="identifyType">
          <div class="identify-send-code">
            <div :class="{identifyCode:true,isFocus:isFocusCode}">
              <img src="../assets/images/index/password.png" alt="">
              <input type="text" @input="smsCodeInput" @blur="handleBlurCode" @focus="hanldeFocusCode" v-model="getSmsCode" placeholder="请输入短信验证码">
              <div class="close" v-if="smcCodeData" @click="smcCodeDataClick"></div>
            </div>
            <div :class="['identify-send',isDisabled ? 'disabled' : '']" @click="smsCodeClick">{{time}}<div class="layer"></div></div>

          </div>
          <div class="login-btn" @click="smsCodeLoginClick">登录<div class="layer"></div></div>
        </div>
        <div class="passwordType" v-if="passwordType">
          <div :class="{password:true,isFocus:isFocusPassword}">
            <img src="../assets/images/index/password.png" alt="">
            <input type="password" @input="passwordInput" @blur="handleBlurPassword" @focus="hanldeFocusPassword" v-model="getPasswordNumber" placeholder="请输入登录密码">
            <div class="close" v-if="passwordData" @click="passwordDataClick"></div>
          </div>
          <div class="login-btn" @click="passwordLoginClick">登录<div class="layer"></div></div>
        </div>
        <div class="forgetPassword-newCustomer">
          <div class="forget-password" @click="forgetPasswordClick">忘记密码</div>
          <div class="new-customer" @click="registerClick">新用户注册</div>
        </div>
      </div>
    </div>
    <Modal ref="modal" :text="text" :flag="flag"></Modal>
  </div>
</template>

<script>
var interval = null;
import Modal from "@/components/Modal.vue";
import { basicSendcode, basicSignin } from "../request/api.js";
export default {
  components: {
    Modal
  },
  computed: {
    getPhoneNumber: {
      get() {
        return this.$store.state.phoneNumber;
      },
      set(newVal) {
        this.$store.commit("handlePhoneNumber", newVal);
      }
    },
    getSmsCode: {
      get() {
        return this.$store.state.smsCode;
      },
      set(newVal) {
        this.$store.commit("handleSmsCode", newVal);
      }
    },
    getPasswordNumber: {
      get() {
        return this.$store.state.passwordNumber;
      },
      set(newVal) {
        this.$store.commit("handlePasswordNumber", newVal);
      }
    }
  },
  data() {
    return {
      phoneData: false,
      smcCodeData: false,
      passwordData: false,
      text: "",
      flag: false,
      isFocusPhone: false,
      isFocusCode: false,
      isFocusPassword: false,
      loginTypeId: 0,
      loginTypeList: [
        {
          text: "验证码登录"
        },
        {
          text: "密码登录"
        }
      ],
      identifyType: true,
      passwordType: false,
      time: "发送验证码", //倒计时
      currentTime: 61,
      isDisabled: false
    };
  },
  methods: {
    phoneDataClick() {
      this.getPhoneNumber = "";
      this.phoneData = false;
    },
    smcCodeDataClick() {
      this.getSmsCode = "";
      this.smcCodeData = false;
    },
    passwordDataClick() {
      this.getPasswordNumber = "";
      this.passwordData = false;
    },
    handleBlurPhone() {
      this.isFocusPhone = false;
    },
    hanldeFocusPhone() {
      this.isFocusPhone = true;
    },
    phoneInput(e) {
      if (e.currentTarget.value.length > 0) {
        this.phoneData = true;
      } else {
        this.phoneData = false;
      }
    },
    smsCodeInput(e) {
      if (e.currentTarget.value.length > 0) {
        this.smcCodeData = true;
      } else {
        this.smcCodeData = false;
      }
    },
    passwordInput(e) {
      if (e.currentTarget.value.length > 0) {
        this.passwordData = true;
      } else {
        this.passwordData = false;
      }
    },
    handleBlurCode() {
      this.isFocusCode = false;
    },
    hanldeFocusCode() {
      this.isFocusCode = true;
    },
    handleBlurPassword() {
      this.isFocusPassword = false;
    },
    hanldeFocusPassword() {
      this.isFocusPassword = true;
    },
    loginTypeClick(index) {
      // 登录方式选择
      this.loginTypeId = index;
      if (index === 0) {
        this.identifyType = true;
        this.passwordType = false;
        this.getPhoneNumber = ''
        this.getSmsCode = ''
        this.getPasswordNumber = ''
      } else {
        this.identifyType = false;
        this.passwordType = true;
        this.getPhoneNumber = ''
        this.getSmsCode = ''
        this.getPasswordNumber = ''
      }
    },
    closeClick() {
      this.$store.state.isLogin = false;
      this.getPhoneNumber = "";
      this.getSmsCode = "";
      this.getPasswordNumber = "";
    },
    smsCodeClick() {
      // 发送验证码
      if (this.getPhoneNumber === "") {
        this.text = "请输入手机号码";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (
        this.getPhoneNumber.length != 11 ||
        !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.getPhoneNumber)
      ) {
        this.text = "格式不正确，请重新输入！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      this.fetchBasicSendcode();
    },
    async fetchBasicSendcode() {
      const data = await basicSendcode({
        mobile: this.getPhoneNumber
      });
      if (data.code === 2000 && data.data.state) {
        this.text = "验证码发送成功！";
        this.flag = true;
        this.$refs.modal.isShow();
        this.getCode();
      } else if (data.code === 2001) {
        this.text = "验证码发送失败！";
        this.flag = false;
        this.$refs.modal.isShow();
      }
    },
    getCode() {
      var currentTime = this.currentTime;
      interval = setInterval(() => {
        currentTime--;
        this.time = currentTime + "秒重新发送";
        this.isDisabled = true;
        if (currentTime <= 0) {
          clearInterval(interval);
          this.time = "发送验证码";
          this.currentTime = 61;
          this.isDisabled = false;
        }
      }, 1000);
    },
    async fetchBasicSignin(type) {
      const params = {
        mobile: this.getPhoneNumber,
        type: type,
        code: type === 1 ? this.getSmsCode : this.getPasswordNumber // 1:验证码  2：密码
      };
      const data = await basicSignin(params);
      if (data.code === 2000) {
        let token = data.data.token;
        let username = data.data.username;
        // 将token和username保存到vuex
        this.$store.state.token = token;
        this.$store.state.username = username;
        // 将用户名称保存到localStorage,因为仅本项目中使用
        window.localStorage.setItem("username", username);
        // 将token和用户信息保存到cookie中，因为控制台也会用到
        this.Cookies.set('LPKTOKEN', token, { path: '/', domain: 'citywavedata.com' });
        this.Cookies.set('USERINFO', JSON.stringify(data.data), { path: '/', domain: 'citywavedata.com' })
        setTimeout(() => {
          window.location.reload();
        }, 500)
      } else if (data.code === 3004) {
        this.text = "验证码已失效";
        this.flag = false;
        this.$refs.modal.isShow();
      } else if (data.code === 4002) {
        this.text = "账号未审核";
        this.flag = false;
        this.$refs.modal.isShow();
      } else if (data.code === 4004) {
        this.text = "账号已禁用";
        this.flag = false;
        this.$refs.modal.isShow();
      } else if (data.code === 4005) {
        this.text = "账号不存在";
        this.flag = false;
        this.$refs.modal.isShow();
      }
    },
    smsCodeLoginClick() {
      if (this.getPhoneNumber === "") {
        this.text = "请输入手机号码";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (
        this.getPhoneNumber.length != 11 ||
        !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.getPhoneNumber)
      ) {
        this.text = "格式不正确，请重新输入！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (this.getSmsCode === "") {
        this.text = "验证码不能为空！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (!/^[0-9]+.?[0-9]*$/.test(this.getSmsCode)) {
        this.text = "请重新输入！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      // 验证码登录
      this.fetchBasicSignin(1);
    },
    passwordLoginClick() {
      if (this.getPhoneNumber === "") {
        this.text = "请输入手机号码";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (
        this.getPhoneNumber.length != 11 ||
        !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.getPhoneNumber)
      ) {
        this.text = "格式不正确，请重新输入！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (this.getPasswordNumber === "") {
        this.text = "密码不能为空，请重新输入！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      if (
        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(
          this.getPasswordNumber
        )
      ) {
        this.text = "请输入8-20位含数字和英文的密码！";
        this.flag = false;
        this.$refs.modal.isShow();
        return;
      }
      // 密码登录
      this.fetchBasicSignin(2);
    },
    forgetPasswordClick() {
      //忘记密码
      this.$router.push("./resetPassword");
    },
    registerClick() {
      // 新用户注册
      this.$router.push("/register");
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.login-container {
  width: 400px;
  height: 385px;
  background: #fff;
  position: absolute;
  top: 38%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;

  .login-wrapper {
    margin: 48px 32px;

    .close {
      width: 16px;
      height: 16px;
      background: url("../assets/images/index/close.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;

      &:hover {
        background: url("../assets/images/index/close-active.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .login-type-list {
      height: 39px;
      display: flex;
      justify-content: space-around;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      .login-type-item {
        height: 24px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #272727;
        line-height: 24px;
        cursor: pointer;

        &.active {
          color: #3880f4;
          position: relative;

          &::after {
            content: "";
            width: 100px;
            height: 3px;
            background: #3880f4;
            position: absolute;
            bottom: -15px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }

    .phone {
      width: 334px;
      height: 42px;
      border-radius: 2px;
      border: 1px solid #e3e3e3;
      margin-top: 32px;
      position: relative;

      &.isFocus {
        border: 1px solid #3880f4;
      }

      &:hover {
        .close {
          display: block;
        }
      }

      img {
        width: 16px;
        height: 16px;
        float: left;
        margin: 14px 0 14px 16px;
      }

      input {
        width: 200px;
        height: 20px;
        float: left;
        margin: 12px 0 12px 8px;
        border: none;
        outline: none;
        line-height: 20px;
      }

      .close {
        display: none;
        width: 16px;
        height: 16px;
        background: url("../assets/images/index/close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 14px;
        right: 16px;
        cursor: pointer;
      }
    }

    .identifyType,
    .passwordType {
      .password {
        width: 334px;
        height: 42px;
        border-radius: 2px;
        border: 1px solid #e3e3e3;
        margin-top: 24px;
        position: relative;

        &.isFocus {
          border: 1px solid #3880f4;
        }

        &:hover {
          .close {
            display: block;
          }
        }

        img {
          width: 16px;
          height: 16px;
          float: left;
          margin: 14px 0 14px 16px;
        }

        input {
          width: 200px;
          height: 20px;
          float: left;
          margin: 12px 0 12px 8px;
          border: none;
          outline: none;
          line-height: 20px;
        }

        .close {
          display: none;
          width: 16px;
          height: 16px;
          background: url("../assets/images/index/close.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 14px;
          right: 16px;
          cursor: pointer;
        }
      }

      .identify-send-code {
        width: 336px;
        height: 44px;
        margin-top: 24px;

        .identifyCode {
          width: 198px;
          height: 42px;
          border: 1px solid #e3e3e3;
          float: left;
          position: relative;

          &.isFocus {
            border: 1px solid #3880f4;
          }

          &:hover {
            .close {
              display: block;
            }
          }

          img {
            width: 16px;
            height: 16px;
            float: left;
            margin: 14px 0 14px 16px;
          }

          input {
            width: 150px;
            height: 20px;
            float: left;
            margin: 12px 0 12px 8px;
            border: none;
            outline: none;
            line-height: 20px;
          }

          .close {
            display: none;
            width: 16px;
            height: 16px;
            background: url("../assets/images/index/close.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 14px;
            right: 16px;
            cursor: pointer;
          }
        }

        .identify-send {
          width: 120px;
          height: 44px;
          background: #3880f4;
          border-radius: 2px;
          text-align: center;
          line-height: 44px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          float: right;
          cursor: pointer;
          position: relative;

          &.disabled {
            color: #999999;
            background: #e3e3e3;
            pointer-events: none;
          }

          .layer {
            width: 120px;
            height: 44px;
            background: rgba(0, 0, 0, 0.25);
            position: absolute;
            top: 0;
            left: 0;
            display: none;
          }

          &:hover {
            .layer {
              display: block;
            }
          }
        }
      }
    }

    ::-webkit-input-placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c0c0c0;
    }

    .login-btn {
      width: 336px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      line-height: 44px;
      background: #3880f4;
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 24px;
      cursor: pointer;
      position: relative;

      .layer {
        width: 336px;
        height: 44px;
        background: rgba(0, 0, 0, 0.25);
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }

      &:hover {
        .layer {
          display: block;
        }
      }
    }

    .forgetPassword-newCustomer {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;

      .forget-password,
      .new-customer {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #272727;
        line-height: 20px;
        cursor: pointer;

        &:hover {
          color: #3880f4;
        }
      }
    }
  }
}
</style>


